import eventHandlers from './eventHandlers';
import dom from "../../../../../../common/ts/core/dom";
import {
    EMAIL_RETENTION_MOBILE_SAVE_ALERT_CTA,
    EMAIL_RETENTION_POPUP_MOBILE,
    EMAIL_RETENTION_POPUP_MOBILE_CLOSE_BUTTON,
    EMAIL_RETENTION_POPUP_MOBILE_CLOSE_ICON,
    EMAIL_RETENTION_POPUP_MOBILE_FORM,
} from "./constants";
import {EventBus} from "../../../../../../common/ts/events/EventBus";
import tracking from "../../../../../../common/ts/core/tracking";
import {FullPageModalCloseEvent} from "../../../../../../common/ts/events/Events";
import emailRetentionForm from "../form";
import apiClassic from "../../../../apiClassic";
import {ALERT_CREATION_SECTION_MANAGE_MERGED} from "../form/constants";
import {SaveEmailAlertRequestedEvent} from "./events";

const eventBus: EventBus = EventBus.getInstance();

function init({
    search,
    pageNumber,
    isPaid,
    toggleTrackingName,
    submitTrackingName,
    isDesktop,
}: {
    search: string,
    pageNumber: number,
    isPaid: boolean,
    toggleTrackingName: string,
    submitTrackingName: string,
    isDesktop: boolean,
}) {
    eventHandlers.init();
    emailRetentionForm.init(
        toggleTrackingName,
        submitTrackingName,
        isPaid,
        isDesktop,
    );

    registerClickEvents(search);
    registerScrollForSaveAlertMobileButton();
}

function registerClickEvents(search: string) {
    const closeRetentionModalButton = dom.select("#close-email-retention-button");
    closeRetentionModalButton?.addEventListener('click', () => {
        eventBus.emit(new FullPageModalCloseEvent({
            id: "email-retention-modal",
        }));

        eventBus.emit(new tracking.TrackAnalyticsEvent({
            name: 'email-retention-modal-close-cta',
        }));
    });

    const closeRetentionModalIcon = dom.select(".js-wl-fullpage-modal-close");
    closeRetentionModalIcon?.addEventListener('click', () => {
        eventBus.emit(new tracking.TrackAnalyticsEvent({
            name: 'email-retention-modal-close-x',
        }));
    });

    const closeRetentionPopupMobileIcon = dom.select(EMAIL_RETENTION_POPUP_MOBILE_CLOSE_ICON);
    closeRetentionPopupMobileIcon?.addEventListener('click', () => {
        eventBus.emit(new dom.HideEvent({selector: EMAIL_RETENTION_POPUP_MOBILE}));
    });

    const closeRetentionPopupMobileButton = dom.select(EMAIL_RETENTION_POPUP_MOBILE_CLOSE_BUTTON);
    closeRetentionPopupMobileButton?.addEventListener('click', () => {
        eventBus.emit(new dom.HideEvent({selector: "#email-retention__popup-mobile"}));
    });

    const goToMobileEmailRetentionFormButton = dom.select(EMAIL_RETENTION_MOBILE_SAVE_ALERT_CTA);
    goToMobileEmailRetentionFormButton?.addEventListener('click', () => {
        eventBus.emit(new tracking.TrackAnalyticsEvent({
            name: 'email-retention-bottom-cta',
        }));

        const emailRetentionMobileForm = dom.select("#js-email-retention-form");
        emailRetentionMobileForm?.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    const formEmailRetentionPopupMobile = dom.select(EMAIL_RETENTION_POPUP_MOBILE_FORM) as HTMLFormElement;
    formEmailRetentionPopupMobile?.addEventListener("submit", (event) => {
        event.preventDefault();
        const formData = new FormData(formEmailRetentionPopupMobile);
        const email = formData.get("email")?.toString();

        if (email) {
            eventBus.emit(new SaveEmailAlertRequestedEvent({ searches: [search], email, wantNews: false }));

            eventBus.emit(new tracking.TrackWebTrackingEvent({
                section: ALERT_CREATION_SECTION_MANAGE_MERGED.toString(),
                sectionName: "ALERT_CREATION_SECTION_MANAGE_MERGED",
                type: "SearchSaved",
                serpUrl: window.location.href,
            }));

            eventBus.emit(new dom.HideEvent({selector: "#email-retention__popup-mobile"}));
        }
    });
}

function registerScrollForSaveAlertMobileButton() {
    const emailRetentionMobileForm = dom.select("#js-email-retention-form");
    if (emailRetentionMobileForm) {
        const saveAlertMobileButton = dom.select("#save-alert-cta");
        if (saveAlertMobileButton) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        saveAlertMobileButton?.classList.add("hide");
                    } else {
                        saveAlertMobileButton?.classList.remove("hide");
                    }
                });
            });
            observer.observe(emailRetentionMobileForm);
        }
    }
}

export default {
    init,
}
